import React from 'react'
import { Menu, Search } from 'lucide-react'
import type { NavItem } from './types'
import { NavEntry, groupItems } from './NavEntry'

export interface NavRailProps {
  items: NavItem[]
  hasMission?: boolean
  expanded: boolean
  onToggleMenu: () => void
  onSearch?: () => void
  menuRef?: React.Ref<HTMLButtonElement>
  /** Ref-Callback für die Wischgeste (nach rechts auf der Leiste öffnet den Drawer). */
  swipeRef?: (el: HTMLElement | null) => void
  moduleName: string
  logoSrc?: string
}

/** Schmale Icon-Leiste. Wisch nach rechts AUF der Leiste, Menü-Button oder Strg+B öffnen den Drawer. */
export function NavRail({ items, hasMission, expanded, onToggleMenu, onSearch, menuRef, swipeRef, moduleName, logoSrc }: NavRailProps) {
  const groups = groupItems(items)
  return (
    <nav className="ui-rail" aria-label={`Hauptnavigation ${moduleName} (Leiste)`} ref={swipeRef as React.Ref<HTMLElement>}>
      <button
        ref={menuRef}
        type="button"
        className="ui-ib ui-rail-menu"
        onClick={onToggleMenu}
        aria-label="Menü öffnen (Strg+B)"
        aria-expanded={expanded}
        aria-controls="ui-drawer"
        title="Menü (Strg+B)"
      >
        <Menu aria-hidden="true" />
      </button>
      {logoSrc && <img src={logoSrc} alt="" className="ui-rail-logo" draggable={false} />}
      <div className="ui-rail-list scrollbar-thin">
        {groups.map((g, gi) => (
          <React.Fragment key={g.name ?? `g${gi}`}>
            {gi > 0 && <span className="ui-sep" role="separator" />}
            {g.items.map(it => <NavEntry key={it.path} item={it} variant="rail" hasMission={hasMission} />)}
          </React.Fragment>
        ))}
      </div>
      {onSearch && (
        <button type="button" className="ui-ib ui-rail-search" onClick={onSearch} aria-label="Suchen (Strg+K)" aria-haspopup="dialog" title="Suchen (Strg+K)">
          <Search aria-hidden="true" />
        </button>
      )}
    </nav>
  )
}
